import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VpnKeyOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vpn_key_off"}/>
}
